// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ContentnewsCommonLayout} from 'app_components/commons/contentnews'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
import { IPost } from 'app_types/campus/postTypes'
// @end

// @ADD Component types
interface IContentnewsCommonProps {
  news: IPost | null
}
interface IContentnewsCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ContentnewsCommon extends Component<IContentnewsCommonProps, IContentnewsCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IContentnewsCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <ContentnewsCommonLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(ContentnewsCommon)
